module.exports = __webpack_public_path__ + "imgs/circleRed.c36a3.png";


//////////////////
// WEBPACK FOOTER
// ./circleRed.png
// module id = zXJW
// module chunks = 0